import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useQuery} from "@tanstack/react-query";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import otherDocumentTypeService from "../../../../services/web/other-document-type-service.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const OtherDocumentTypeList = () => {
    const navigate = navigateHook();

    const [isLoading, setIsLoading] = useState(false);
    const [columnDefs, setColumnDefs] = useState([]);
    const [filter, setFilter] = useState("")
    const gridRef = useRef();

    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    useEffect(() => {
        const columns = [
            {headerName: "Nome", field: "name", flex: 1, comparator: aggridUtils.nullLastComparator}
        ];

        setColumnDefs(columns);
    }, []);


    const {data: documentTypes, status } = useQuery({
        queryFn: () =>  otherDocumentTypeService.list().then(({data}) => {
            return data?? [];
        }),
        queryKey: ['otherDocumentTypes'],
    });

    useEffect(() => {
        if (status === 'success') setIsLoading(false)
        else setIsLoading(true)
    }, [status]);

    const onCellClicked = ({data}) => {
        navigate(`/otherDocumentTypes/form/${data.id}`);
    }
    const clearFilter = () => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            null,
        );
        setFilter("");
    }

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            filter,
        );
    }, [filter]);

    const handleInput = ({target: {value}}) => {
        setFilter(value)
    }

    useGlobalKey("Enter", onFilterTextBoxChanged);
    useGlobalKey("Escape", clearFilter);
    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Tipos de documentos</Template.Title>
                <Button onClick={() => navigate(`/otherDocumentTypes/form`)}>
                    <FaPlus /> Adicionar tipo de documento
                </Button>
            </Template.Header>
            <Template.Body className="flex flex-col space-y-2">
                <Card>
                    <Card.Body>
                        <div className="flex items-end gap-4">
                            <div className="flex-1">
                                <InputForm id="search" value={filter} onChange={handleInput}
                                           label="Nome"/>
                            </div>

                            <div className="flex gap-2">
                                <Button target="text-white" title="Limpar" onClick={() => clearFilter()}>
                                    <FaEraser />
                                </Button>

                                <Button target="primary" title="Buscar" onClick={() => onFilterTextBoxChanged()}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-153px)] w-full">
                            <AgGridReact
                                ref={gridRef}
                                rowData={documentTypes}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                theme={theme}
                                onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default OtherDocumentTypeList;
